<template lang="pug">
v-card(color="#0F354F" :dark='isDark' flat).rounded-lg
  v-toolbar(dark color="orange darken-2" dense flat).rounded-t-lg
    v-spacer
    v-toolbar-title(style="text-shadow: 0px 2px 3px rgba(0,0,0,0.6);") Ingreso al Sistema SISEP
    v-spacer
  v-card-text.pa-7.pt-4.pb-3
    div(style="margin-top:-15px;")
      v-img(src="https://sisep.minedu.gob.bo/img/sin-conexion.png" max-width="80" max-height="80").center.mt-9.mb-2
      h4(style="font-size:18pt;color:#AAD6EB;font-weight:normal;line-height:20pt;").text-center El sistema SISEP<br>se encuentra en proceso<br>de actualización de información
      h4(style="font-size:15pt;font-weight:normal;").text-center.mt-4 El sistema será restablecido<br>en aproximadamente 10 minutos.
      h4(style="font-size:15pt;font-weight:normal;").text-center.mt-3.mb-6 Agradecemos su comprensión
      //-h3.orange.text-center lorem
</template>

<style lang="stylus">
.custompicker div div ul
  background-image linear-gradient(rgb(30, 65, 94) 10%, rgb(43, 91, 132) 90%);

.custompicker div div .active
  color #FFF !important

.custompicker .v-picker__body
  background-image linear-gradient(rgb(30, 65, 94) 10%, rgb(43, 91, 132) 90%);
</style>

<script>
export default {

  props:{
    isDark:{
      type: Boolean,
      required: false,
      default: false
    }
  },

  data: vm => ({
    expoMode: false
  }),
};
</script>
